import { instance, objectToParams } from '../api';

// Endpoints del informe de Reposición:
//   - JSON paginado + stats (`/replenishment`)
//   - Agregado mensual para el line chart (`/replenishment/monthly`)
//   - PDF Análisis (`/replenishment/analysis/pdf`)
//   - PDF por Series (`/replenishment/series/pdf`)
//   - Excel (`/replenishment/excel`)

export const getReportsReplenishment = (args) => instance.get(`/api/v1/reports/replenishment?${objectToParams(args)}`);

export const getReportsReplenishmentMonthly = (args) =>
  instance.get(`/api/v1/reports/replenishment/monthly?${objectToParams(args)}`);

export const getReportsReplenishmentAnalysisPdf = (args) =>
  instance.get(`/api/v1/reports/replenishment/analysis/pdf?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsReplenishmentSeriesPdf = (args) =>
  instance.get(`/api/v1/reports/replenishment/series/pdf?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsReplenishmentExcel = (args) =>
  instance.get(`/api/v1/reports/replenishment/excel?${objectToParams(args)}`, { responseType: 'blob' });
